module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/async/loaders/syncloader.js!./loaders/async/a.js
 ** module id = 1
 ** module chunks = 0
 **/